import { Route } from 'vue-router';
import { MenuConfigItemChild } from '../type';

/** 路由匹配核心规则 */
export const fnIsRouteMatch = (item: MenuConfigItemChild, route: Route) => {
  const { name, meta } = route;
  /** 1. 路由完全匹配上 */
  const baseNameMatch = item.routerName === name;
  /** 2. 路由没匹配上，但是路由里配置了属于这个组 */
  const groupMatch = meta && meta.tabGroup === item.routerName;
  /** 3. 默认匹配行为(1、2满足一条就行) */
  const nameMatch = !!(baseNameMatch || groupMatch);
  /** 4. 优先自定义匹配，没有则用默认匹配 */
  return item.routeMatch ? item.routeMatch(route, nameMatch) : nameMatch;
};
